
import { Component, EventEmitter, OnInit, Output, ElementRef, ViewChild, Input } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Observable, Subscriber } from 'rxjs';
import { UmsService } from '../ums.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { PdfviewerComponent } from '../pdfviewer/pdfviewer.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AlertboxComponent } from '../alertbox/alertbox.component';
import { ModalpopService } from '../modalpop.service';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { ConformationModelComponent } from '../conformation-model/conformation-model.component';
import { finalize } from 'rxjs/operators';
@Component({
  selector: 'app-document-details',
  templateUrl: './document-details.component.html',
  styleUrls: ['./document-details.component.scss']
})
export class DocumentDetailsComponent implements OnInit {
  @Input() tabName: string = '';
  @ViewChild('fileInput') fileInput!: ElementRef;
  @ViewChild('fileInput') fileInputRefs!: ElementRef[];
  @Output() next = new EventEmitter<void>();
  // @Output() prev = new EventEmitter<void>();
  @Output() prev = new EventEmitter<boolean>();
  @Output() first = new EventEmitter<void>();
  dialogRef: MatDialogRef<any>;
  errormessage: string;
  uploadDoc: any;
  fileName: string;
  filePre: any;
  imgFile: any;
  ducumentList: any;
  isDivShow = false;
  errMsg: any;
  disabled = false;
  printDisabled = true;
  fileNameinput = true;
  isFileInputNot = true
  addmissionData: any;
  session: string;
  inputTimeout: any;
  StuSrNum
  StuDocName
  StuRmk
  InstId: any;
  formSubmitted = false;
  ducumentList2: any;
  SavedDocument: any[] = []
  DateDisable = false
  abc
  xyz
  DocErr: any;
  DocRecords: any[];
  selectedRow: any | null = null;
  valuesArray: any;
  isRedText: boolean;
  stuSrNoArray: string[] = [];
  tabs: string;
  displayName: any;
  PersonalDetails: any;
  addressDetails: any;
  ReservationDetails: any;
  ExamDtails: any;
  laterEntry: string;
  activeFlowObject: any;
  arrActiveFlow: any;
  SnNo: any;
  snNo: number | null = null;
  constructor(private fb: FormBuilder, public router: Router,
    public umsService: UmsService, public datepipe: DatePipe,
    public dialog: MatDialog, private modalPopupService: ModalpopService,
    private spinner: NgxSpinnerService) { }
  @ViewChild('fileUploader') fileUploader: ElementRef;
  documentDetailsForm: FormGroup;
  submitButton = true;
  updateButton = false;
  StudentPersonalId = sessionStorage.getItem('StudentPersonalId');
  CoId;
  CgId;
  prepopulationFlag: boolean;
  isPrepopulationEmpty: boolean;
  prepopulationAddmissionFlag: boolean;


  ngOnInit(): void {
    this.submitButton = true;
    this.updateButton = false;
    this.prepopulationFlag = false;
    this.isPrepopulationEmpty = true;
    this.prepopulationAddmissionFlag = false;
    this.disabled = false
    this.session = sessionStorage.getItem('session');
    this.StudentPersonalId = sessionStorage.getItem('StudentPersonalId');
    let i = 0;
    this.documentDetailsSummary();
    this.documentDetailsForm = this.fb.group({
      "StuRemarkConfirm": new FormControl(''),
      "StuRemarkCheck": new FormControl('', Validators.required),
      "StuHardCopy": new FormControl(''),
      "HardCopyFile": new FormControl(''),
      arrData: this.fb.array([]),
    });

    // this.getScrutiny();
    // this.fetchDocument();
    this.getSecretData()
    this.fetchDocument2();
    this.getPersonalDetails();
    this.prepopulationContact();
    this.prepopulationOfAddmission();
  }

  documentDetailsSummary() {
    let payload = {};
    payload['StuId'] = parseInt(sessionStorage.getItem('StudentPersonalId'));

    this.umsService.studentCompSummary(payload).subscribe((res) => {
      if (res.status && res.data && res.data.length > 0) {
        this.snNo = res.data[0].SnNo;
        console.log('SessionId / SnNo:', this.snNo);
      }
    });
  }

  getFeeStatus(StuId) {
    const payload = {};
    payload['StuId'] = StuId;
    payload['SnNo'] = this.session;
    this.umsService.getFeeStatus(payload).subscribe(res => {
      if (res.status) {
        console.log('fees status response i get is', res.data);
        this.getScrutiny(StuId)
      }
      else {
        this.disabled = false;
      }
    }, (ERROR: HttpErrorResponse) => {
      this.disabled = false;
    })
  }


  getScrutiny(StuId) {
    this.spinner.show();
    const payload = {};
    this.DocErr = []
    payload['StudentId'] = StuId
    this.umsService.fetchScrutinyLock(payload).subscribe(res => {
      this.tabs = res.data[0].Tabs;
      if (res.status) {
        this.spinner.hide();
        if (res.data.length == 0 || res.data[0]['Status'] == 'DCERR') {
          console.log('res.data of scrutiny', res.data);

          if (res.data[0].Tabs.includes('Document Upload')) {
            this.DocErr = res.data;
            if (this.DocErr.length > 0) {
              let stusrno = this.DocErr[0]['StuSrNo'];
              this.valuesArray = stusrno.split(',');
            }
            this.disabled = false;
            this.printDisabled = true
            this.fileNameinput = true;
          } else {
            this.disabled = true;
            this.printDisabled = false
            this.fileNameinput = false;
          }
        }
        else {
          this.disabled = true;
          this.printDisabled = false
          this.fileNameinput = false;
        }

      }
      else {
        this.spinner.hide();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    });
  }

  fileUploads: string[] = [];

  onChange($event: Event, rowIndex: number) {
    const file = ($event.target as HTMLInputElement).files[0];
    const fileName = file.name;
    this.fileName = fileName;

    const faControl = (<FormArray>this.documentDetailsForm.controls['arrData']).at(rowIndex);

    if (file.size >= 512000) {
      this.errormessage = "Please upload file less than 500KB";
      let data = {
        message: this.errormessage,
        title: 'Information',
        icon: 'fas fa-close'
      };
      this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
      this.dialogRef.afterClosed().subscribe(() => {
        this.fileName = '';
        ($event.target as HTMLInputElement).value = '';
        faControl['controls'].docFile.setValue('');
        faControl['controls'].DocumentFile.setValue('');
      });
    } else {
      this.errormessage = '';
      let ext = fileName.substring(fileName.lastIndexOf(".") + 1).toLowerCase();
      if (ext === "pdf") {
        this.convertToBase64(file, rowIndex);
        faControl['controls'].DocumentFile.setValue(fileName);
        faControl['controls'].DocumentFile.markAsTouched();
      } else {
        faControl['controls'].docFile.setValue('');
        faControl['controls'].DocumentFile.setValue('');
        faControl['controls'].DocumentFile.markAsTouched();
        let data = {
          message: 'Please Upload Only PDF File',
          title: 'Information',
          icon: 'fas fa-close'
        };
        this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
        this.dialogRef.afterClosed().subscribe(() => {
          this.fileName = '';
          ($event.target as HTMLInputElement).value = '';
        });
      }
    }
  }


  convertToBase64(file: File, rowIndex: number) {
    const observable = new Observable((subscriber: Subscriber<any>) => {
      this.readFile(file, subscriber);
    });

    observable.subscribe((d) => {
      this.uploadDoc = d;
      while (this.fileUploads.length <= rowIndex) {
        this.fileUploads.push(null);
      }
      this.fileUploads[rowIndex] = d;
      let base64Str = d.split(',');
      let filee = base64Str[1];
      const faControl = (<FormArray>this.documentDetailsForm.controls['arrData']).at(rowIndex);
      faControl['controls'].docFile.setValue(filee);
      faControl['controls'].DocumentFile.setValue(file.name);
      this.dialog.open(PdfviewerComponent, {
        width: "400px",
        height: "500"
      });

    });
  }

  readFile(file: File, subscriber: Subscriber<any>) {
    const fileReader = new FileReader();
    fileReader.readAsDataURL(file);
    fileReader.onload = () => {
      subscriber.next(fileReader.result);
      subscriber.complete();
    };
    fileReader.onerror = (error) => {
      subscriber.error(error);
      subscriber.complete();
    };
  }


  AddScrtDetails() {
    let payload = {};
    payload['StuId'] = parseInt(this.StudentPersonalId);
    payload['SessionId'] = this.snNo;
    payload['CgCode'] = this.CgId;
    payload['CoCode'] = this.CoId;
    this.umsService.AddScrtDetails(payload).subscribe((res) => {
      if (res.status) {
        // this.first.emit();
        this.NewCoSch();
      }
      else {

      }
    })
  }


  AddScrtDetails1() {
    let payload = {};
    payload['StuId'] = parseInt(this.StudentPersonalId);
    payload['SessionId'] = this.snNo;
    payload['CgCode'] = this.CgId;
    payload['CoCode'] = this.CoId;
    this.umsService.AddScrtDetails(payload).subscribe((res) => {
      if (res.status) {
        // this.first.emit();
        this.spinner.hide()
        let data = {}
        data['message'] = "Submitted Successfully"
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
        this.dialogRef.afterClosed().subscribe(result => {

          this.redirect('Fees')
        });


      }
      else {

      }
    })
  }

  UpdScrtDetails() {
    let payload = {};
    payload['StuId'] = parseInt(this.StudentPersonalId);
    payload['SessionId'] = this.snNo;
    payload['CgCode'] = this.CgId;
    payload['CoCode'] = this.CoId;
    this.umsService.UpdScrtDetails(payload).subscribe((res) => {
      if (res.status) {
        this.spinner.hide()
        let data = {}
        data['message'] = this.errMsg;
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
        this.dialogRef.afterClosed().subscribe(result => {

          this.redirect('Fees')
        });
      }
      else {

      }
    })
  }


  saveApplicationDetails() {
    // const currentDate = new Date();
    // const formattedDate = currentDate.toISOString().slice(0, 10);
    this.spinner.show()
    let payload = {};
    payload['StuId'] = this.StudentPersonalId;
    payload['SessionId'] = this.snNo;
    payload['CgCode'] = this.CgId;
    payload['CoCode'] = this.CoId;
    payload['ApplicationName'] = 'Registration'
    // payload['ApplicationSubDate'] = formattedDate
    this.umsService.saveApplicationDetails(payload).subscribe((res) => {
      if (res.status) {
        // this.spinner.hide()
      } else {
        // this.spinner.hide()
      }
    })
  }

  fetchDocument() {
    this.spinner.show()
    let payload = {};
    payload['StudentID'] = this.StudentPersonalId;
    this.umsService.fetchStudDocumentDetails(payload).pipe(finalize(() => {
      this.prepopulationFlag = true;
      console.log("prepopulationFlag in document details: ", this.prepopulationFlag);
      this.DisableSaveUpdateButton();
    })).subscribe((res) => {
      console.log("res status in document details: ", res.status);
      if (res.status) {
        this.spinner.hide();
        this.ducumentList = res.data;
        this.SavedDocument
        if (this.SavedDocument.length == 0) {
          console.log("inside if condition of document details ");
          this.isPrepopulationEmpty = true;
          this.submitButton = true
          this.updateButton = false
          this.disabled = false
          this.isDivShow = false;
          const documentsArray = this.documentDetailsForm.get('arrData') as FormArray;
          // const arrayOfObjects = res.data;
          const arrayOfObjects = res.data.filter(
            obj => obj.DocumentName !== 'Fee receipt already paid'
          );
          const documentFormGroup = this.fb.group({
            arrData: this.fb.array([]),
          });
          arrayOfObjects.forEach((obj, i) => {
            const tempObj = {}
            let regex = '';
            if (obj.RegEx !== null) {
              regex = obj.RegEx
            }
            const validators = (obj.IsRequired && obj.RegEx != null) ? [Validators.required, Validators.pattern(obj.RegEx)] : (obj.IsRequired && obj.RegEx == null) ? [Validators.required] : [];
            const validators1 = (obj.IsRequired && obj.HasExpiryDate) ? [Validators.required] : [];
            const validators2 = obj.IsRequired ? [Validators.required] : [];
            tempObj['DocumentID'] = new FormControl(obj.DocumentID),
              tempObj['DocumentName'] = new FormControl(obj.DocumentName),
              tempObj['IsRequired'] = new FormControl(obj.IsRequired),
              tempObj['HasExpiryDate'] = new FormControl(obj.HasExpiryDate),
              tempObj['IsConditional'] = new FormControl(obj.IsConditional),
              tempObj['ConditionField'] = new FormControl(obj.ConditionField),
              tempObj['ConditionValue'] = new FormControl(obj.ConditionValue),
              tempObj['RegEx'] = new FormControl(obj.RegEx),
              tempObj['SortSequence'] = new FormControl(obj.SortSequence),
              tempObj['docFile'] = new FormControl(''),
              tempObj['docNo'] = new FormControl(''),
              tempObj['StuSrNo'] = new FormControl(''),
              tempObj['DocumentFile'] = new FormControl('', validators2),
              tempObj['StuDocIssue'] = new FormControl('', validators1),
              tempObj['StuDocExpiry'] = new FormControl('', validators1)
            for (const key in tempObj) {
            }
            const creds = this.documentDetailsForm.controls.arrData as FormArray;
            creds.push(new FormGroup(tempObj));
          })
        } else {
          console.log("inside else condition of document details ");
          this.isPrepopulationEmpty = false;
          this.submitButton = false
          this.updateButton = true

          this.isDivShow = true;
          this.umsService.disable8 = false;
          const documentsArray = this.documentDetailsForm.get('arrData') as FormArray;
          // const arrayOfObjects = res.data;
          const arrayOfObjects = res.data.filter((obj: any) => {
            if (obj.DocumentName === 'Fee receipt already paid') {
              const feeDoc = this.SavedDocument.find(
                (d: any) => d.StuDocumentName === 'Fee receipt already paid'
              );
              return feeDoc && feeDoc.StuFileUpload;
            }
            return true;
          });
          const documentFormGroup = this.fb.group({
            arrData: this.fb.array([]),
          });


          arrayOfObjects.forEach((obj, i) => {
            const tempObj = {}
            let regex = '';
            if (obj.RegEx !== null) {
              regex = obj.RegEx
            }
            let StuRemarkCheck = false;
            if (this.SavedDocument[0].StuRemarkCheck == 1) {
              StuRemarkCheck = true;
            } else {
              StuRemarkCheck = false;
            }
            let StuHardCopy = false;
            if (this.SavedDocument[0].StuHardCopy == 1) {
              StuHardCopy = true;
            }
            else {
              StuHardCopy = false;
            }
            if (!this.SavedDocument[i]) {
              this.abc = '';
              this.xyz = '';
            }
            else if (this.SavedDocument[i].StuDocIssue == "1900-01-01" && this.SavedDocument[i].StuDocExpiry == "1900-01-01") {
              this.abc = '';
              this.xyz = '';
            }
            else if (this.SavedDocument[i].StuDocIssue == "1900-01-01") {
              this.abc = '';

            }
            else if (this.SavedDocument[i].StuDocExpiry == "1900-01-01") {

              this.xyz = '';
            }
            else {
              this.abc = this.SavedDocument[i].StuDocIssue;
              this.xyz = this.SavedDocument[i].StuDocExpiry;
            }
            const validators = (obj.IsRequired && obj.RegEx != null) ? [Validators.required, Validators.pattern(obj.RegEx)] : (obj.IsRequired && obj.RegEx == null) ? [Validators.required] : [];
            const validators1 = (obj.IsRequired && obj.HasExpiryDate) ? [Validators.required] : [];
            const validators2 = obj.IsRequired ? [Validators.required] : [];
            tempObj['DocumentID'] = new FormControl(obj.DocumentID),
              tempObj['DocumentName'] = new FormControl(obj.DocumentName),
              tempObj['IsRequired'] = new FormControl(obj.IsRequired),
              tempObj['HasExpiryDate'] = new FormControl(obj.HasExpiryDate),
              tempObj['IsConditional'] = new FormControl(obj.IsConditional),
              tempObj['ConditionField'] = new FormControl(obj.ConditionField),
              tempObj['ConditionValue'] = new FormControl(obj.ConditionValue),
              tempObj['RegEx'] = new FormControl(obj.RegEx),
              tempObj['SortSequence'] = new FormControl(obj.SortSequence),
              tempObj['docFile'] = new FormControl(''),
              tempObj['docNo'] = new FormControl('')
            tempObj['StuSrNo'] = new FormControl(this.SavedDocument[i]?.StuSrNo),
              tempObj['DocumentFile'] = new FormControl(this.SavedDocument[i]?.StuFileUpload),
              tempObj['StuDocIssue'] = new FormControl(this.abc, validators1),
              tempObj['StuDocExpiry'] = new FormControl(this.xyz, validators1)
            tempObj['StuRemarkConfirm'] = new FormControl(this.SavedDocument[0].StuRemarkConfirm);
            tempObj['StuRemarkCheck'] = new FormControl(this.SavedDocument[0].StuRemarkCheck);
            tempObj['StuHardCopy'] = new FormControl(this.SavedDocument[0].StuHardCopy);

            for (const key in tempObj) {
            }
            const creds = this.documentDetailsForm.controls.arrData as FormArray;
            creds.push(new FormGroup(tempObj));
          })
          console.log('this.DocErr', this.DocErr);

          if (this.DocErr.length > 0) {
            let stusrno = this.DocErr[0]['DocumentName'];
            this.valuesArray = stusrno.split(',');
          }
        }
      }
      else {
        //this.isPrepopulationEmpty = true;
        console.log("isPrepopulationEmpty in else condition: ", this.isPrepopulationEmpty)
        this.spinner.hide();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    });
  }

  checkcolor(id): any {
    if (id.value['DocumentName'] == '' || id.value['DocumentName'] == null) {
      let stuSrNoString = id.value['DocumentName']
      if (this.valuesArray && this.valuesArray.includes(stuSrNoString)) {
        this.isRedText = true;
      }
      else {
        this.isRedText = false;
      }
    }
    else {
      let stuSrNoString = id.value['DocumentName'].toString();
      if (this.valuesArray && this.valuesArray.includes(stuSrNoString)) {
        this.isRedText = true;
      }
      else {
        this.isRedText = false;
      }

    }



  }


  fetchDocument2() {
    // this.spinner.show();
    let payload = {};
    payload['StuId'] = this.StudentPersonalId;
    this.umsService.fetchDocumentDetails(payload).subscribe((res) => {
      if (res.status) {
        // this.spinner.hide();
        this.ducumentList2 = res.data;
        this.ducumentList2.forEach((item: any) => {
          item.isViewable = false;
          console.log('item', item);
          if (!item.StuFileUpload
          ) {
            return;
          }
          this.umsService.fetchDocument({ filePath: item.StuFileUpload, viewFile: true }).subscribe(
            (docRes: any) => {
              item.isViewable = docRes.isViewable;
            },
            () => {
              item.isViewable = false;
            }
          );
        });
        this.SavedDocument = this.ducumentList2;
        this.documentDetailsForm.controls['StuRemarkConfirm'].setValue(res.data[0].StuRemarkConfirm);
        this.documentDetailsForm.controls['StuRemarkCheck'].setValue(res.data[0].StuRemarkCheck);
        this.documentDetailsForm.controls['StuHardCopy'].setValue(res.data[0].StuHardCopy);
        if (res.data.length == 0) {
          this.isDivShow = false;

        }
        else {
          this.isDivShow = true;
          this.umsService.disable8 = false;
        }
        this.getFeeStatus(res.data[0].StuId)
        this.fetchDocument();
      }
      else {
        this.fetchDocument();
        this.spinner.hide()
      }
    }, (ERROR: HttpErrorResponse) => {
      this.fetchDocument();
      this.spinner.hide();
    });
  }

  fetchForupdate(data) {
    this.spinner.show();
    this.updateButton = true;
    this.submitButton = false;
    let payload = {};
    payload['StuId'] = data.StuId;
    payload['StuDocId'] = data.StuDocId;
    this.umsService.fetchDocumentDetails(payload).subscribe((res) => {

      if (res.status) {
        this.spinner.hide()
        let data = res.data[0];
        sessionStorage.setItem('StuDocId', data.StuDocId)
        let StuRemarkCheck = false;
        if (data.StuRemarkCheck == 1) {
          StuRemarkCheck = true;
        } else {
          StuRemarkCheck = false;
        }

        let StuHardCopy = false;
        if (data.StuHardCopy == 1) {
          StuHardCopy = true;
        } else {
          StuHardCopy = false;
        }

        let preArr = [];
        const tmpDict = {};
        tmpDict['StuId'] = new FormControl(data.StuId);
        tmpDict['StuSrNo'] = new FormControl(data.StuSrNo);
        tmpDict['StuDocumentName'] = new FormControl(data.StuDocumentName),
          tmpDict['StuRemark'] = new FormControl(data.StuRemark);
        tmpDict['StuFileUpload'] = new FormControl(data.StuFileUpload);
        tmpDict['StuRemarkConfirm'] = new FormControl(data.StuRemarkConfirm);
        tmpDict['StuRemarkCheck'] = new FormControl(data.StuRemarkCheck);
        tmpDict['StuHardCopy'] = new FormControl(data.StuHardCopy);
        tmpDict['CoCode'] = new FormControl(this.CoId);
        tmpDict['CgCode'] = new FormControl(this.CgId);
        tmpDict['StuDocExpiry'] = new FormControl(data.StuDocExpiry);
        tmpDict['StuDocIssue'] = new FormControl(data.StuDocIssue);
        const creds = this.documentDetailsForm.controls.arrData as FormArray;
        creds.push(new FormGroup(tmpDict));
      } else {
        this.spinner.hide();
      }

    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    });

  }
  // getTabName(e) {
  //   this.displayName = e;
  // }
  getTabDisplayName(): string {
    return `Current Tab: ${this.tabName}`;
  }

  update() {
    const creds = this.documentDetailsForm.get('arrData') as FormArray;
    if (creds.invalid || this.documentDetailsForm.invalid) {
      creds.controls.forEach(element => {

        if (element.value.DocumentFile === '' || element.value.DocumentFile === null) {
          element.get('DocumentFile').markAsTouched();


        }
        // element.get('StuSrNo').markAsTouched();
        if (element.value.HasExpiryDate == true) {

          element.get('StuDocExpiry').markAsTouched();
          element.get('StuDocIssue').markAsTouched();
        }
      })
      this.documentDetailsForm.get('StuRemarkCheck').markAsTouched();
      return;
    }
    this.Update();
  }

  async Update() {
    this.spinner.show()
    let payload = this.documentDetailsForm.value;
    let iserror = false;
    payload['StuFileUpload'] = '';
    var bar = new Promise<void>((resolve, reject) => {
      payload.arrData.forEach(async (element, index, array) => {
        element.StuFileUpload = this.fileUploads[index];
        let da = element.StuDocIssue;
        let da1 = element.StuDocExpiry;
        let payload = {};
        payload['StuId'] = this.StudentPersonalId;
        payload['StuSrNo'] = element.StuSrNo;
        payload['StuDocumentName'] = element.DocumentName;
        payload['StuRemark'] = element.StuRemark;
        let savefile = null;
        if (this.fileUploads[index]) {
          savefile = await this.saveFiles(element, index);
        }
        const oldFile = (this.SavedDocument[index] as any)?.StuFileUpload;
        payload['StuFileUpload'] = savefile?.file ? savefile.file : this.fileUploads[index] ? this.fileUploads[index] : oldFile;
        payload['StuRemarkConfirm'] = this.documentDetailsForm.value.StuRemarkConfirm;
        payload['StuRemarkCheck'] = this.documentDetailsForm.value.StuRemarkCheck;
        payload['StuHardCopy'] = this.documentDetailsForm.value.StuHardCopy;
        payload['CoCode'] = this.CoId;
        payload['CgCode'] = this.CgId;
        payload['SessionId'] = this.snNo;
        payload['StuDocIssue'] = this.datepipe.transform(da, 'yyyy-MM-dd');
        payload['StuDocExpiry'] = this.datepipe.transform(da1, 'yyyy-MM-dd');
        payload['StuDocId'] = this.SavedDocument[index]?.StuDocId || 0;
        payload['LoginId'] = parseInt(sessionStorage.getItem('StudentRGID'));
        payload['HardCopyFile'] = this.documentDetailsForm.value.HardCopyFile;
        setTimeout(() => {
          this.umsService.updateDocumentDetails(payload).subscribe(res => {
            // this.spinner.hide();
            if (res.status == false) {
              // this.spinner.hide();
              iserror = true;
              this.errMsg = res.message;
            } else {
              // this.spinner.hide();
              iserror = false;
              this.errMsg = res.message;
            }
            if (index === array.length - 1) resolve();

            //this.documentDetailsForm.reset();
            this.fileUploader.nativeElement.value = null;
            this.documentDetailsForm.reset();
            this.printDisabled = false
          }, (ERROR: HttpErrorResponse) => {
            this.spinner.hide();
            iserror = true;
            this.errMsg = ERROR.error.message;
            if (index === array.length - 1) resolve();
          });
        }, index * 2000);
      });

    })
    bar.then(() => {
      this.spinner.hide();
      if (iserror == false) {
        this.umsService.setTabSaved('documentTab');
        let data = {};
        data['message'] = this.errMsg || 'Document Details Updated Successfully';
        data['title'] = 'Information';
        data['icon'] = 'fas fa-check';

        this.dialogRef =
          this.modalPopupService.openPopup<AlertboxComponent>(
            AlertboxComponent,
            data
          );

    if ((this.tabs &&
        this.umsService.isRequiredTabsSaved(this.tabs)) || this.tabs == undefined) {

          const data = {};
          data['message'] =
            'Are You Sure You Have Updated ' +
            this.tabs +
            ' Tabs. Do You Want To Proceed?';

          data['title'] = 'Alert';
          data['icon'] = 'fa fa-question';

          this.dialogRef =
            this.modalPopupService.openPopup<ConformationModelComponent>(
              ConformationModelComponent,
              data
            );
          this.dialogRef.afterClosed().subscribe(result => {
            if (result === 'yes') {
              this.UpdScrtDetails();
              if (this.tabs?.includes('Wrong Payment')) {
                this.router.navigate(['/Fees']);
              }
            }
          });
        }
      } else {
        this.spinner.hide();
        let data = {}
        data['message'] = this.errMsg
        data['title'] = 'Alert'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
      }
    });
  }

  // showbase64(e) {
  //   const dialogRef3 = this.dialog.open(PdfviewerComponent,
  //     {
  //       width: "400px",
  //       height: "500px",
  //       data: e.value.DocumentFile
  //     });
  // }
  showbase64(e, index) {
     const savedDoc = this.getSavedDocument(e.value.DocumentName);
  const documentFile = savedDoc?.StuFileUpload || e.value.DocumentFile;
    if (this.fileUploads[index]) {
      this.dialog.open(PdfviewerComponent, {
        width: "400",
        height: "500px",
        data: this.fileUploads[index]
      });
      return;
    }
    this.spinner.show();

    if (
      documentFile === null ||
      documentFile.startsWith('data:')
    ) {
      this.spinner.hide();

      this.dialog.open(PdfviewerComponent, {
        width: "400px",
        height: "500px",
        data: documentFile
      });

    } else {
      let payload = {
        filePath: documentFile
      };

      this.umsService.fetchDocument(payload).subscribe((res) => {
        if (res.status) {
          this.spinner.hide();

          this.dialog.open(PdfviewerComponent, {
            width: "400px",
            height: "500px",
            data: res.doc
          });

        } else {
          let payload = {
            StuId: this.StudentPersonalId,
            fileNames: [documentFile]
          };

          this.umsService.getFilesDetails(payload).subscribe((res) => {
            this.spinner.hide();

            this.dialog.open(PdfviewerComponent, {
              width: "400px",
              height: "500px",
              data: res.files[0].base64Data
            });
          });
        }
      });
    }
  }

  back() {
    this.prev.emit(false);
  }

  prepopulationOfAddmission() {
    this.spinner.show();
    this.StudentPersonalId = sessionStorage.getItem('StudentPersonalId');
    let payload = {};
    payload['StuId'] = this.StudentPersonalId;
    this.umsService.fetchAddmissionDetails(payload).pipe(finalize(() => {
      this.prepopulationAddmissionFlag = true;
      console.log("prepopulationAddmissionFlag in document details: ", this.prepopulationAddmissionFlag);
    })).subscribe((res) => {
      if (res.status) {
        this.spinner.hide();
        this.addmissionData = res.data[0];
        this.CoId = res.data[0].StuCoId;
        this.CgId = res.data[0].StuCgId;
        console.log("this.addmissionDatathis.addmissionData", this.addmissionData);
        this.getExam(this.addmissionData.StuEmId);
        this.getExamStreamData(res.data[0].StuCoId, res.data[0].StuBrId)
      }
      else {
        this.spinner.hide()
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    })
  }

  getExamStreamData(id, StrId) {
    console.log('id', id);
    console.log('StrId', StrId);

    this.spinner.show();
    const payload = {};
    payload['CoCode'] = id;
    payload['EmId'] = 0;
    this.umsService.getExamStream(payload).subscribe(res => {
      this.spinner.hide();
      if (res.status && res.data.length > 0) {
        res.data.forEach(element => {
          if (element.StrId == StrId) {
            console.log('element', element);

            // this.addmissionData.push({ "StrCode": element.StrCode });
            this.addmissionData.StuBrId = element.StrCode
          }
        });


      } else {
        // this.showchat = true;
      }

    },
    );
  }

  deletesemRow(index) {
    const creds = this.documentDetailsForm.controls.arrData as FormArray;
    creds.controls.forEach(element => {
      this.StuSrNum = element.value['StuSrNo'];
      this.StuDocName = element.value['StuDocumentName'];
      this.StuRmk = element.value['StuRemark'];

    })
    if (index !== 0 && (this.StuSrNum == '' && this.StuDocName == '' && this.StuRmk == '')) {
      (<FormArray>this.documentDetailsForm.get("arrData")).removeAt(index);
    }
    else {
      let data = {}
      data['message'] = "This Row Can Not Be Deleted"
      data['title'] = 'Information'
      data['icon'] = 'fas fa-check'
      this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);

    }

  }

  getSecretData() {
    this.spinner.show();
    let payload = {};
    this.umsService.getSecretData().subscribe((res) => {
      if (res.status) {
        this.spinner.hide();
        this.InstId = res.projectPharam['ClubPartTrans'];
        this.activeFlowObject = res.projectPharam['ActiveFlow'];
        this.SnNo = res.projectPharam['SnNo'];
        this.arrActiveFlow = JSON.parse(this.activeFlowObject);
      }
      else {
        this.spinner.hide();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    })
  }

  Print() {
    let payload1 = {}
    payload1['StuId'] = sessionStorage.getItem('StudentPersonalId');
    payload1['RgNo'] = sessionStorage.getItem('StudentRGID');
    let jsonString = JSON.stringify(payload1).replace(/\\/g, '');

    var filter: any;
    filter = {

      "LoginId": parseInt(sessionStorage.getItem('StudentRGID')),
      "RptCode": 99,
      "InstName": '',
      "InstNo": this.InstId,
      "ShId": '',
      "CgCode": '',
      "RollNo": '',
      "Cent": '',
      "TnCode": '',
      "EsId": '',
      "CsNo": '',
      "PgBreak": '',
      "StrId": '',
      "StrCode": '',
      "RgNo": parseInt(sessionStorage.getItem('StudentRGID')),
      "UC": '',
      "Ledger": '',
      "RegnRoll": '',
      "DsCode": '',
      "CoCode": '',
      "SnNo": parseInt(sessionStorage.getItem('session')),
      "Extra1": JSON.stringify(payload1),
    }

    var payload: any;
    payload = filter;
    this.umsService.setData(JSON.stringify(payload));
    this.redirect('download-details')
  }

  redirect(to): void {
    this.router.navigate([to]);
  }

  onInputChange(val, index) {
    const tempData = val.target.value;
    const arrData = this.documentDetailsForm.get('arrData') as FormArray;
    const isDuplicate = this.stuSrNoArray.some((item: any) => item === tempData);
    // If it's not a duplicate, push the new item
    if (!isDuplicate) {
      this.stuSrNoArray[index] = tempData;
    }
    else if (isDuplicate) {
      arrData.controls[index].get('StuSrNo').setErrors({ Duplicate: true });
      arrData.controls[index].get('StuSrNo').setValue('')
    }


  }

  issueDateValidation(item, i) {
    const currentIssueDate = item.value.StuDocIssue
    const formattedDate = currentIssueDate.toISOString().slice(0, 10);

    const currentExpireDate = item.value.StuDocExpiry
    const formattedExpiryDate = currentExpireDate.toISOString().slice(0, 10);

    if ((formattedExpiryDate != '' || formattedExpiryDate != null) && formattedDate > formattedExpiryDate) {
      let data = {}
      data['message'] = 'from Date should be less than expiry date'
      data['title'] = 'Information'
      data['icon'] = 'fas fa-close'
      this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
      let arr = this.documentDetailsForm.get('arrData') as FormArray
      arr.at(i).get('StuDocIssue').setValue('');
    }
  }

  toDateValidation(item, i) {
    if (item.value.StuDocIssue == null) {
      let data = {}
      data['message'] = 'Select First Issue Date'
      data['title'] = 'Information'
      data['icon'] = 'fas fa-close'
      this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
      let arr = this.documentDetailsForm.get('arrData') as FormArray
      arr.at(i).get('StuDocExpiry').setValue('');
    }
    if (item.value.StuDocIssue == "") {
      let data = {}
      data['message'] = 'Select First Issue Date'
      data['title'] = 'Information'
      data['icon'] = 'fas fa-close'
      this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
      let arr = this.documentDetailsForm.get('arrData') as FormArray
      arr.at(i).get('StuDocExpiry').setValue('');
    }
    else if (item.value.StuDocIssue > item.value.StuDocExpiry) {
      let data = {}
      data['message'] = 'Expiry Date should be greater than Issue Date'
      data['title'] = 'Information'
      data['icon'] = 'fas fa-close'
      this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
      let arr = this.documentDetailsForm.get('arrData') as FormArray
      arr.at(i).get('StuDocExpiry').setValue('');
    }
  }


  NewCoSch() {
    this.spinner.show()
    const payload = {};
    payload['CoCode'] = this.CoId;
    payload['CShStatus'] = '';
    payload['LoginId'] = 0;
    payload['CShSnNo'] = this.snNo;
    this.umsService.NewCoSch(payload).subscribe(res => {
      if (res.status) {
        //step 6) if course is scheduled take its shid and check registration list
        this.spinner.hide()
        this.NewSearchCoSch(res.data[0]['CShId'])
      }
      else {
        this.spinner.hide()
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide()
    });
  }

  NewSearchCoSch(ShId) {
    this.spinner.show()
    const payload = {};
    payload['CEcShId'] = ShId;
    this.umsService.NewSearchCoSch(payload).subscribe(res => {
      if (res.status) {
        //Step 7)registration list take its ecid and call registration api
        this.spinner.hide()
        this.RegnForm(res.data[0]['CEcId'])
      }
      else {
        this.spinner.hide()
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide()
    });
  }

  RegnForm(EcId) {
    console.log("im in regn form", this.PersonalDetails);

    // if(this.ExamDtails['EmSrNo'] > 1){
    //   this.laterEntry = 'L'
    // }
    // else{
    //   this.laterEntry = ''
    // }
    this.spinner.show()
    console.log("iiiiiiiiiiiiiiiiiii", this.addmissionData['StuSubjectRg']);

    // const SubValues = this.addmissionData['StuSubjectRg'].join(',').trim();
    let subjects = this.addmissionData['StuSubjectRg'];
    let result = (Array.isArray(subjects) ? subjects : [subjects]).join(',').trim();
    console.log("SubValues", result);

    const payload = {};
    payload['CSExBr'] = '';
    payload['Code'] = '';
    payload['Colg'] = '';
    payload['valid'] = 'Y';
    payload['changed'] = '';
    payload['CgCodee'] = '';
    payload['Batch'] = '';
    payload['Name'] = this.PersonalDetails['StuFirstNameEng'];
    payload['RgNo'] = this.PersonalDetails['StuRgNo'];
    payload['FormNo'] = '';
    payload['CgCode'] = this.CgId;
    payload['Chng'] = 'Y';
    payload['Valid'] = '';
    payload['Father'] = this.PersonalDetails['StuMidNameEng'];
    payload['Mother'] = this.PersonalDetails['StuMothNameEng'] ? this.PersonalDetails['StuMothNameEng'] : '';
    payload['BirthDate'] = this.PersonalDetails['StuBirthDate'];
    payload['Sex'] = this.PersonalDetails['StuGender'];
    payload['Cate'] = 'R';
    payload['Caste'] = this.ReservationDetails['StuConstiSubCate'] ? this.ReservationDetails['StuConstiSubCate'] : '';     //this.Arr['StuConstiSubCate']
    payload['EMail'] = this.PersonalDetails['EmailID'] ? this.PersonalDetails['EmailID'] : '';
    payload['Medium'] = 'E';
    payload['Nation'] = '1';
    payload['Mobile'] = this.PersonalDetails['StuNumber'] ? this.PersonalDetails['StuNumber'] : '';
    payload['Addr1'] = this.addressDetails['StuAddrC'] ? this.addressDetails['StuAddrC'] : '';
    payload['Addr2'] = '';
    payload['Addr3'] = '';
    payload['Addr1P'] = this.addressDetails['StuAddrP'] ? this.addressDetails['StuAddrP'] : '';
    payload['Addr2P'] = '';
    payload['Addr3P'] = '';
    payload['Pin'] = this.addressDetails['StuPinC'] ? this.addressDetails['StuPinC'] : '';
    payload['PinP'] = this.addressDetails['StuPinP'] ? this.addressDetails['StuPinP'] : '';
    payload['Place'] = '';
    payload['StrCode'] = this.addmissionData['StuBrId'] ? this.addmissionData['StuBrId'] : 0;
    payload['PlaceP'] = '';
    payload['ExSub'] = '';
    payload['Sub'] = result;
    payload['EcId'] = EcId;
    payload['CoCode'] = this.CoId
    payload['SnNo'] = parseInt(this.session);
    payload['EmSrNoF'] = this.ExamDtails['EmSrNo'];
    payload['msg'] = '';
    payload['EmSkip'] = this.laterEntry; //this.laterEntry
    payload['StuId'] = this.PersonalDetails['StuId'];
    //from this.Arr all data of student should be inserted in payload
    console.log("paaaaalll", payload);


    this.umsService.addRegiFormScrutiny(payload).subscribe((res) => {
      if (res.status) {
        //step 8) if registration done successfully then call validate api
        this.spinner.hide()
        this.Validate(EcId);

      } else {
        this.spinner.hide()
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide()
      let data = {};
      data['message'] = ERROR.error.message;
      data['title'] = 'Alert';
      data['icon'] = 'fas fa-close';
      // this.dialogRef1 = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    });
  }

  Validate(EcId) {
    //once validate api is called this student is considered as successfully inserted in registration table.
    this.spinner.show()
    const payload = {};
    payload['Batch'] = '';
    payload['EcId'] = EcId;
    payload['Inst'] = this.InstId;
    this.umsService.validateRegiForm(payload).subscribe((res) => {
      if (res.status) {
        this.spinner.hide();
        this.first.emit();
      } else {
        this.spinner.hide()
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide()
      let data = {};
      data['message'] = ERROR.error.message;
      data['title'] = 'Alert';
      data['icon'] = 'fas fa-close';
      // this.dialogRef1 = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    });
  }

  getPersonalDetails() {
    this.spinner.show();
    let payload = {};
    payload['StuRgNo'] = sessionStorage.getItem('StudentRGID');
    this.umsService.fetchPersonalDetails(payload).subscribe((res) => {
      if (res.status) {
        this.spinner.hide();
        // console.log("student personal details",res.data[0]);
        this.PersonalDetails = res.data[0];
        this.getContactDetails(this.PersonalDetails)
        this.getReservationsDetails(this.PersonalDetails)
      } else {
        this.spinner.hide();

      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide()
    })
  }

  getContactDetails(Id) {
    this.spinner.show();
    let payload = {};
    payload['StuId'] = Id.StuId
    this.umsService.fetchContactDetails(payload).subscribe((res) => {
      if (res.status) {
        this.spinner.hide();
        console.log("student contact details", res.data[0]);
        this.addressDetails = res.data[0];
      } else {
        this.spinner.hide();

      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide()
    })
  }

  getReservationsDetails(Id) {
    this.spinner.show();
    let payload = {};
    payload['StuId'] = Id.StuId
    this.umsService.fetchReservationDetails(payload).subscribe((res) => {
      if (res.status) {
        this.spinner.hide();
        console.log("student contact details", res.data[0]);
        this.ReservationDetails = res.data[0];
      } else {
        this.spinner.hide();

      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide()
    })
  }

  getExam(EmId) {
    this.spinner.show();
    let payload = {};
    payload['EmId'] = EmId
    this.umsService.fetchExam(payload).subscribe((res) => {
      console.log("student exam details", res.data[0]);
      this.ExamDtails = res.data[0];
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide()
    })
  }

  async save() {
    const creds = this.documentDetailsForm.get('arrData') as FormArray;
    if (creds.invalid || this.documentDetailsForm.invalid) {
      console.log("this.documentDetailsForm", this.documentDetailsForm);

      creds.controls.forEach(element => {
        if (element.value.HasExpiryDate == true) {
          element.get('StuDocExpiry').markAsTouched();
          element.get('StuDocIssue').markAsTouched();

        }
        if (element.value.IsRequired == 1) {
          element.get('DocumentFile').markAsTouched();
          // element.get('StuSrNo').markAsTouched();
        }
      })
      this.documentDetailsForm.get('StuRemarkCheck').markAsTouched();
    }
    else {
      this.spinner.show()
      let payload = this.documentDetailsForm.value;
      let iserror = false;
      payload['StuFileUpload'] = '';
      var bar = new Promise<void>((resolve, reject) => {
        payload.arrData.forEach(async (element, index, array) => {
          element.StuFileUpload = this.fileUploads[index];
          let payload = {};
          let da = element.StuDocIssue;
          let da1 = element.StuDocExpiry;
          payload['StuId'] = this.StudentPersonalId;
          payload['StuSrNo'] = element.StuSrNo;
          payload['StuDocumentName'] = element.DocumentName;
          payload['StuRemark'] = element.StuRemark;
          let savefile = null;
          if (this.fileUploads[index]) {
            savefile = await this.saveFiles(element, index);
          }
          const oldFile = (this.SavedDocument[index] as any)?.StuFileUpload;
          payload['StuFileUpload'] = savefile?.file ? savefile.file : this.fileUploads[index] ? this.fileUploads[index] : oldFile;
          payload['StuRemarkConfirm'] = this.documentDetailsForm.value.StuRemarkConfirm;
          payload['StuRemarkCheck'] = this.documentDetailsForm.value.StuRemarkCheck;
          payload['StuHardCopy'] = this.documentDetailsForm.value.StuHardCopy;
          payload['CoCode'] = this.CoId;
          payload['CgCode'] = this.CgId;
          payload['SessionId'] = this.snNo;
          payload['StuDocIssue'] = this.datepipe.transform(da, 'yyyy-MM-dd');
          payload['StuDocExpiry'] = this.datepipe.transform(da1, 'yyyy-MM-dd');
          payload['LoginId'] = parseInt(sessionStorage.getItem('StudentRGID'));
          payload['HardCopyFile'] = '';
          setTimeout(() => {
            this.umsService.addDocumentDetails(payload).subscribe(res => {

              if (res.status == false) {

                iserror = true;
                this.errMsg = res.message;
              } else {

                iserror = false;
                this.errMsg = res.message;
              }
              if (index === array.length - 1) resolve();
              this.documentDetailsForm.reset();
              this.fileUploader.nativeElement.value = null;
              this.printDisabled = false
            }, (ERROR: HttpErrorResponse) => {
              this.spinner.hide()
              iserror = true;
              this.errMsg = ERROR.error.message;
              if (index === array.length - 1) resolve();
            });
          }, index * 2000);
        });
        this.saveApplicationDetails();
      })
      bar.then(() => {

        if (iserror == false) {
          // this.spinner.hide();
          this.AddScrtDetails1();
          // let data = {}
          // data['message'] = "Submitted Successfully"
          // data['title'] = 'Information'
          // data['icon'] = 'fas fa-check'
          // this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
        } else {
          this.spinner.hide();
          let data = {}
          data['message'] = this.errMsg
          data['title'] = 'Alert'
          data['icon'] = 'fas fa-close'
          this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);

        }
      });

    }
  }

  submitStudentDetails() {

    if (this.arrActiveFlow[0]['FeesBeforeScrutiny'] == 1) {
      this.saveWithScrutiny();
    }
    else if (this.arrActiveFlow[0]['FeesBeforeScrutiny'] == 0) {
      this.save();
    }

  }





  async saveWithScrutiny() {
    console.log('this.addmissionData', this.addmissionData);
    console.log(this.documentDetailsForm)
    const creds = this.documentDetailsForm.get('arrData') as FormArray;
    if (creds.invalid || this.documentDetailsForm.invalid) {
      creds.controls.forEach(element => {
        if (element.value.HasExpiryDate == true) {
          element.get('StuDocExpiry').markAsTouched();
          element.get('StuDocIssue').markAsTouched();

        }
        if (element.value.IsRequired == 1) {
          element.get('DocumentFile').markAsTouched();
          // element.get('StuSrNo').markAsTouched();
        }
      })
      this.documentDetailsForm.get('StuRemarkCheck').markAsTouched();
    }
    else {
      this.spinner.show()
      let payload = this.documentDetailsForm.value;
      let iserror = false;
      payload['StuFileUpload'] = '';
      var bar = new Promise<void>((resolve, reject) => {
        payload.arrData.forEach(async (element, index, array) => {
          element.StuFileUpload = this.fileUploads[index];
          let payload = {};
          let da = element.StuDocIssue;
          let da1 = element.StuDocExpiry;
          payload['StuId'] = this.StudentPersonalId;
          payload['StuSrNo'] = element.StuSrNo;
          payload['StuDocumentName'] = element.DocumentName;
          payload['StuRemark'] = element.StuRemark;
          let savefile = null;

          if (this.fileUploads[index]) {
            savefile = await this.saveFiles(element, index);
          }
          const oldFile = (this.SavedDocument[index] as any)?.StuFileUpload;
          payload['StuFileUpload'] = savefile?.file || this.fileUploads[index] || oldFile;
          payload['StuRemarkConfirm'] = this.documentDetailsForm.value.StuRemarkConfirm;
          payload['StuRemarkCheck'] = this.documentDetailsForm.value.StuRemarkCheck;
          payload['StuHardCopy'] = this.documentDetailsForm.value.StuHardCopy;
          payload['CoCode'] = this.CoId;
          payload['CgCode'] = this.CgId;
          payload['SessionId'] = this.snNo;
          payload['StuDocIssue'] = this.datepipe.transform(da, 'yyyy-MM-dd');
          payload['StuDocExpiry'] = this.datepipe.transform(da1, 'yyyy-MM-dd');
          payload['LoginId'] = parseInt(sessionStorage.getItem('StudentRGID'));
          setTimeout(() => {
            this.umsService.addDocumentDetails(payload).subscribe(res => {
              this.spinner.hide();
              if (res.status == false) {
                this.spinner.hide()
                iserror = true;
                this.errMsg = res.message;
              } else {
                this.spinner.hide()
                iserror = false;
                this.errMsg = res.message;
              }
              if (index === array.length - 1) resolve();
              this.documentDetailsForm.reset();
              this.fileUploader.nativeElement.value = null;
              this.printDisabled = false
            }, (ERROR: HttpErrorResponse) => {
              this.spinner.hide()
              iserror = true;
              this.errMsg = ERROR.error.message;
              if (index === array.length - 1) resolve();
            });
          }, index * 2000);
        });
        this.saveApplicationDetails();

      })
      bar.then(() => {
        this.spinner.hide();
        if (iserror == false) {
          this.spinner.hide();
          this.AddScrtDetails();
          let data = {}
          data['message'] = "Submitted Successfully"
          data['title'] = 'Information'
          data['icon'] = 'fas fa-check'
          this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
        } else {
          this.spinner.hide();
          let data = {}
          data['message'] = this.errMsg
          data['title'] = 'Alert'
          data['icon'] = 'fas fa-close'
          this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);

        }
      });

    }
  }

  DisableSaveUpdateButton() {
    console.log("inside disable save update button of document details")
    if (this.prepopulationFlag && this.prepopulationAddmissionFlag) {
      console.log("is prepopulation empty of document details", this.isPrepopulationEmpty)
      if (this.isPrepopulationEmpty) {
        this.submitButton = true;
        this.updateButton = false;
        console.log("this is submit button in document details: ", this.submitButton)
      }
      else {
        this.submitButton = false;
        this.updateButton = true;
        console.log("this is update button button in document details: ", this.updateButton)
      }
    }
  }
  prepopulationContact() {
    let payload = {};
    payload['StuId'] = this.StudentPersonalId;
    this.umsService.fetchContactDetails(payload).subscribe(res => {
      if (res.status) {
        if (res.data[0].StuNationality === 'OS') {
          this.umsService.studentProgressList['StudentReservation'] = 1;
        }
      }
    }, (ERROR: HttpErrorResponse) => {

    })

  }
  saveFiles(element, index): Promise<any> {
    return new Promise((resolve, reject) => {
      const payload = {
        filePath: 'student_documents/' + parseInt(this.StudentPersonalId) + '_' + element.DocumentID + '_' +
          element.DocumentName.trim().toLowerCase().replace(/ /g, '_'),
        base64: this.fileUploads[index],
        StuId: this.StudentPersonalId
      };

      this.umsService.saveFiles(payload).subscribe(
        (res) => {
          console.log('Uploaded:', res);
          resolve(res);
        },
        (error) => {
          console.error(error);
          reject(error);
        }
      );
    });
  }
  getSavedDocument(documentName: string): any {
  return this.SavedDocument.find(
    x => x.StuDocumentName?.trim().toLowerCase() ===
         documentName?.trim().toLowerCase()
  );
}
}